module.exports = __webpack_public_path__ + "static/media/scanpay-logo.10892e29.svg";